import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";

// Auto-recover from stale lazy-loaded chunks after a new deploy.
// When a user has an old tab open and we ship new JS, the old chunk
// filenames disappear and dynamic imports fail with
// "Importing a module script failed" / "Failed to fetch dynamically imported module".
// We do a one-time hard reload so the browser fetches the new index.html + chunks.
const RELOAD_KEY = "__chunk_reload_attempt__";
const isChunkLoadError = (msg: string) =>
  /Importing a module script failed|Failed to fetch dynamically imported module|Loading chunk [\d]+ failed|error loading dynamically imported module/i.test(
    msg
  );

const tryReload = () => {
  try {
    const last = Number(sessionStorage.getItem(RELOAD_KEY) || "0");
    // Avoid infinite reload loops — only reload once every 10s.
    if (Date.now() - last < 10_000) return;
    sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
    window.location.reload();
  } catch {
    window.location.reload();
  }
};

window.addEventListener("error", (e) => {
  const msg = e?.message || (e?.error && e.error.message) || "";
  if (isChunkLoadError(msg)) tryReload();
});

window.addEventListener("unhandledrejection", (e) => {
  const reason: any = e?.reason;
  const msg = (reason && (reason.message || String(reason))) || "";
  if (isChunkLoadError(msg)) tryReload();
});

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
